// extracted by mini-css-extract-plugin
export default {"InviteFriendPop":"ImgPop_InviteFriendPop__uzNFf","modalHeader":"ImgPop_modalHeader__Vr1sX","formControl":"ImgPop_formControl__pyhKM"};